import React, { useState, useEffect, useRef } from "react";
import Select from 'react-select'
import AsyncSelect from 'react-select/async';


const BestPlaceForm = (props) => {
  const { formik } = props;
  // const [isLoading, setIsLoading] = useState(false);
  // const formRef = useRef();
  const [regions, setRegions] = useState([]);
  const [listings, setListings] = useState([]);
  const fetchRegions = async () => {
    const resp = await fetch('/suggestions/regions.json');
    const data = await resp.json()
    console.log('dd', data.resources);
    setRegions(data.resources);
  }   

  const loadListingOptions = (
    inputValue,
    callback
  ) => {
    fetch(`/admin/listings.json?region=${values.region_id||''}&query=${inputValue || ''}`).then((resp) => resp.json()).then((resp) => {
      console.log('resources', resp);
      setListings(resp.resources)
      const listingOptions = resp.resources.map((cat) => ({label: `${cat.name} (${cat.full_address})`, value: cat.id}));
      callback(listingOptions)  
    })
  };

  console.log("BestPlaceForm", props);


  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = formik;

  console.log('errors', errors);
  const handleChangeRegion = (e) => {
    console.log('handleChangeRegion', e)
    setFieldValue('region_id', e ? e.value : null)
    loadListingOptions('', () => {

    })
  }

  useEffect(() => {
    fetchRegions();
    loadListingOptions(values.listing_id, () => {

    })
  }, []);
  const regionOptions = regions.map((cat) => ({label: cat.name, value: cat.id}));
  const listingOptions = listings.map((cat) => ({label: `${cat.name} (${cat.full_address})`, value: cat.id}));

  return (
    <React.Fragment>
          <div className="row with-forms">

            <div className="col-md-12">
              <h5>
                Region
                <sup className="required">*</sup>
              </h5>
              <Select 
                className="react-select-wrapper"
                classNamePrefix="react-select"
                options={regionOptions} 
                name="region_id"
                required={true}
                value={regionOptions.find((cat) => (cat.value === values.region_id))}
                onChange={handleChangeRegion}
              />   
             
            </div>
            </div>
            <div className="row with-forms">

            <div className="col-md-12">
              <h5>
                Listing
                <sup className="required">*</sup>
              </h5>
           
            <AsyncSelect 
              className="react-select-wrapper"
              classNamePrefix="react-select"
              value={listingOptions.find((cat) => (cat.value === values.listing_id))}
              cacheOptions 
              loadOptions={loadListingOptions} 
              defaultOptions={listingOptions}
              isClearable
              isDisabled={!values.region_id}
              onChange={e => {return setFieldValue('listing_id', e ? e.value : null)}}
            />
            </div>
            </div>
            <div className="row with-forms">

            <div className="col-md-12">
              <h5>
                Highlight
                <sup className="required">*</sup>
              </h5>
              <input
                type="text"
                name="highlight"
                id="highlight"
                placeholder="e.g best overall massage"
                autoComplete="off"
                value={`${values.highlight || ""}`}
                onChange={handleChange}
                onBlur={handleBlur}
                required={true}
                className={
                  errors.highlight && touched.highlight
                    ? "search-field error"
                    : "search-field"
                }
              />
            </div>
            </div>
            <div className="row with-forms">

            <div className="col-md-12">
              <h5>
                Title
                <sup className="required">*</sup>
              </h5>
              <input
                type="text"
                name="title"
                id="title"
                placeholder="e.g Don Quixote"
                autoComplete="off"
                value={`${values.title || ""}`}
                onChange={handleChange}
                onBlur={handleBlur}
                required={true}
                className={
                  errors.title && touched.title
                    ? "search-field error"
                    : "search-field"
                }
              />
            </div>
            </div>
            <div className="row with-forms">

            <div className="col-md-12">
              <h5>
                Excerpt
                <sup className="required">*</sup>
              </h5>
              <textarea
                name="excerpt"
                id="excerpt"
                placeholder="e.g super hot girls, and managers that speak chinese,..."
                autoComplete="off"
                value={`${values.excerpt || ""}`}
                onChange={handleChange}
                onBlur={handleBlur}
                required={true}
                className={
                  errors.excerpt && touched.excerpt
                    ? "search-field error"
                    : "search-field"
                }
              />
            </div>
          </div>
            <div className="row with-forms">

            <div className="col-md-12">
              <h5>
                Position/Priority
              </h5>
              <input
                min="0"
                type="number"
                name="position"
                id="position"
                placeholder="Listing's position of the best place region"
                value={`${values.position || ""}`}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  errors.position && touched.position
                    ? "search-field error"
                    : "search-field"
                }
              />
            </div>
          </div>

        
         
       
   
    </React.Fragment>
  );
};

export default BestPlaceForm;
